export const columns = [
  {
    title: 'Họ và tên',
    key: 'name',
    sorter: true,
    dataIndex: 'name',
  },
  {
    title: 'Email login',
    key: 'loginEmail',
    dataIndex: 'loginEmail',
  },
  {
    title: 'Email nhận thông báo',
    key: 'email',
    dataIndex: 'email',
  },
];
